export const SMART_EDIT_FEATURE = 'smartEdit';
